export type FlipkartDuplicateFsnSource = {
  campaign_id: string | null;
  banners?: { productId?: string | null }[] | null;
};

const DUPLICATE_STEP_LABELS: Record<string, string> = {
  ad_groups: 'creating ad groups',
  config: 'copying ad group settings',
  pause: 'pausing ad groups and products',
  live: 'setting the campaign live',
  sync: 'saving the campaign',
};

export function duplicateCampaignName(sourceName: string | null | undefined): string {
  const name = sourceName?.trim();
  return name ? `${name} copy` : 'Campaign copy';
}

export function duplicateStepLabel(step: string): string {
  return DUPLICATE_STEP_LABELS[step] ?? step;
}

export function fsnsFromAdGroups(
  groups: FlipkartDuplicateFsnSource[],
  campaignId: string
): string[] {
  const ids: string[] = [];
  const seen = new Set<string>();
  for (const group of groups) {
    if (group.campaign_id !== campaignId) continue;
    for (const banner of group.banners ?? []) {
      const id = banner.productId?.trim();
      if (!id || seen.has(id)) continue;
      seen.add(id);
      ids.push(id);
    }
  }
  return ids;
}

export function removeFsn(ids: string[], fsn: string): string[] {
  return ids.filter((id) => id !== fsn);
}

export function addPastedFsns(ids: string[], text: string): string[] {
  const next = [...ids];
  const seen = new Set(ids);
  for (const part of text.split(/[\s,]+/)) {
    const token = part.trim();
    if (!token || seen.has(token)) continue;
    seen.add(token);
    next.push(token);
  }
  return next;
}
